import { SwitchGroup } from '../..'

export const createBlankGroup = (): SwitchGroup => {
  return {
    id: crypto.randomUUID(),
    label: '',
    conditions: [
      { id: crypto.randomUUID(), property: '', operator: '', value: '' }
    ]
  }
}
